import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { MaterialImportsModule } from 'src/app/material-imports.module';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DASHBOARD_PAGE_CARDS_SORTING_STORAGE_KEY, getDashboardSetting } from 'src/app/utility/dashboard-helper';


interface ISort  {
  label: string;
  value: string;
}
@Component({
  selector: 'app-thingie-sort',
  templateUrl: './thingie-sort.component.html',
  styleUrls: ['./thingie-sort.component.scss'],
  imports: [ MaterialImportsModule, MatOptionModule,]
})
export class ThingieSortComponent implements OnInit {
  @Input()
  public sorts: ISort[] = [
    {
      label: 'State',
      value: 'RELEVANCE',
    }, {
      label: 'Last created',
      value: 'LAST_CREATED',
    }, {
      label: 'First created',
      value: 'FIRST_CREATED',
    }, {
      label: 'Last modified',
      value: 'LAST_MODIFIED',
    }, {
      label: 'First modified',
      value: 'FIRST_MODIFIED',
    }
  ];

  @Input()
  public selectedSort = 'RELEVANCE';

  protected selectedSortLabel = '';

  @Output() public callbackFunction: EventEmitter<string> = new EventEmitter();

  constructor(private auth: AuthService) { }

  public ngOnInit(): void {
    void this.auth.getCurrentUserId().then((currentUserID) => {
      this.selectedSort = getDashboardSetting(currentUserID, DASHBOARD_PAGE_CARDS_SORTING_STORAGE_KEY) || 'RELEVANCE';
      this.updateSortUI();
    });
  }

  protected sortChange(event: MatSelectChange) {
    this.selectedSort = event.value;
    this.updateSortUI();
    this.callbackFunction.emit(this.selectedSort);
  }

  private updateSortUI() {
    const sort: ISort | undefined = this.sorts.find(s => s.value === this.selectedSort);

    if (sort !== undefined) {
      this.selectedSortLabel = `Sort by ${sort.label}`;
    }
  }
}
